export default "__VITE_ASSET__3e49a632__"